import { Chip } from '@mui/material';
import { blue } from '@mui/material/colors';
import { lighten, SxProps } from '@mui/system';
import React, { useState } from 'react';
import ChipsPreview from '../../person/detailsPage/editComponents/ChipsPreview';
import { SIZES } from '../constants/constants';

/**
 * Props for the TagsPreview component.
 */
type TagsPreviewProps = {
    /**
     * Array of tag strings to display.
     */
    tags: Array<string>;
    sx?: SxProps;
    chipSx?: SxProps;
    tileWidth?: number;
};

export default function TagsPreview({ tags = [], sx = {}, chipSx, tileWidth }: TagsPreviewProps) {
    const [lastElementToFitIndex, setLastElementToFitIndex] = useState<number | null>(null);

    if (!tags || tags.length === 0) {
        return null;
    }

    const remainingLabels = lastElementToFitIndex !== null ? tags.length - lastElementToFitIndex - 1 : 0;

    return (
        <ChipsPreview
            customFields={tags.map((label) => ({ value: [label] }))}
            size={SIZES.small}
            unwrapSkillsContainer
            setLastElementToFitIndex={setLastElementToFitIndex}
            hideMoreElement
            lastElementToFitIndex={lastElementToFitIndex}
            sx={sx}
            chipSx={chipSx}
            tileWidth={tileWidth}
            customMoreElement={(handleClick) =>
                remainingLabels > 0 && (
                    <Chip
                        aria-label={`show +${remainingLabels} more tags`}
                        label={`+${remainingLabels}`}
                        sx={
                            chipSx ??
                            ((theme) => ({
                                backgroundColor: lighten(blue[100], 0.5),
                                color: theme.palette.mode === 'dark' ? 'common.black' : 'text.secondary'
                            }))
                        }
                        size={SIZES.small}
                        component="button"
                        onClick={handleClick}
                    />
                )
            }
        />
    );
}
